import PropTypes from "prop-types";
import React from "react";
import MailchimpSubscribe from "react-mailchimp-subscribe";
import { useToasts } from "react-toast-notifications";
import { sendUserInfo } from "../../redux/actions/subscriptionActions";
import { useDispatch, useSelector } from "react-redux";

const CustomForm = ({ status, message, onValidated }) => {
  const { addToast } = useToasts();
  const dispatch = useDispatch();
  let email;
  let name;
  let state;
  const submit = () => {
    // email &&
    //   email.value.indexOf("@") > -1 &&
    //   onValidated({
    //     EMAIL: email.value,
    //     FNAME: name.value,
    //   });
    dispatch(sendUserInfo({ email: email.value, name: name.value, state:state.value }, addToast));
    email.value = "";
    name.value = "";
    state.value="";
  };

  return (
    <div className="subscribe-form-2">
      <div className="mc-form">
        <div className="dv-mob w-100 pr-10 pl-40">
          <input
            className="w-100 "
            style={{ marginRight: "0.5rem" }}
            ref={(node) => (name = node)}
            type="text"
            placeholder="Tu Nombre"
            required
          />
        </div>

        <div className=" dv-mob w-100 pr-10 pl-10">
          <input
            type="text"
            required
            placeholder="Ciudad / Departamento"
            name="state"
            ref={(node) => (state = node)}
          />
        </div>
        <div className=" dv-mob w-100 pr-10 pl-10">
          <input
            className="w-100 "
            ref={(node) => (email = node)}
            type="email"
            placeholder="Tu Email"
            required
          />
        </div>

        <div className="clear-2">
          <button className="button" onClick={submit}>
            <i className="fa fa-long-arrow-right"></i>
          </button>
        </div>
      </div>

      {status === "sending" && (
        <div style={{ color: "#3498db", fontSize: "12px" }}>Enviando...</div>
      )}
      {status === "error" && (
        <div
          style={{ color: "#e74c3c", fontSize: "12px" }}
          dangerouslySetInnerHTML={{ __html: "Por favor revisa los campos" }}
        />
      )}
      {status === "success" && (
        <div
          style={{ color: "#2ecc71", fontSize: "12px" }}
          dangerouslySetInnerHTML={{ __html: "Gracias por subscribirte!" }}
        />
      )}
    </div>
  );
};

const SubscribeEmail = ({ mailchimpUrl }) => {
  return (
    <div className="mobile-form w-100">
      <MailchimpSubscribe
        url={mailchimpUrl}
        render={({ subscribe, status, message }) => (
          <CustomForm
            status={status}
            message={message}
            onValidated={(formData) => subscribe(formData)}
          />
        )}
      />
    </div>
  );
};

SubscribeEmail.propTypes = {
  mailchimpUrl: PropTypes.string,
};

export default SubscribeEmail;
